import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {FeedbackPopupData} from '../FeedbackPopupData';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {FeedbackPopupService} from '../feedback-popup.service';
import {FEEDBACK_RESOURCE_TOKEN, FeedbackService} from '../../../services/FeedbackService';
import {Quiz} from '../../question-preview/types/quiz';
import {Observable, Subscription} from 'rxjs';

@Component({
    selector: 'mm-feedback-creation-popup',
    templateUrl: './feedback-creation-popup.component.html',
    styleUrls: ['./feedback-creation-popup.component.scss'],
    standalone: false
})
export class FeedbackCreationPopupComponent implements OnInit, OnDestroy {
    @Input({required: true})
    public data!: FeedbackPopupData;

    @Input()
    public allowReset: boolean = false;

    public feedbackTextFormControl: FormControl<string>;
    public questionPreview$: Observable<Quiz> | undefined;

    public questionPreviewOpen: boolean = false;
    private valueChangesSubscription = new Subscription();

    constructor(public feedbackPopupService: FeedbackPopupService,
                @Inject(FEEDBACK_RESOURCE_TOKEN) private feedbackResource: FeedbackService,
                private formBuilder: FormBuilder) {
        this.feedbackTextFormControl = this.formBuilder.control<string>(this.feedbackPopupService.getInitialText(), {
            validators: [Validators.required, Validators.minLength(10), Validators.maxLength(3000)],
            nonNullable: true
        });
    }

    public ngOnInit(): void {
        this.valueChangesSubscription = this.feedbackTextFormControl.valueChanges.subscribe(value => {
            this.feedbackPopupService.setFeedbackText(value);
        });


        const questionId = this.data.questionId;
        if (questionId !== undefined && this.isFeedbackAboutQuestion()) {
            this.questionPreview$ = this.feedbackResource.getQuestionPreview(this.data.learningPackageId, questionId);
        }
    }

    public changeQuestionPreview(): void {
        this.questionPreviewOpen = !this.questionPreviewOpen;
    }

    public sendFeedback(): void {
        this.feedbackPopupService.showSpinner();
        this.feedbackPopupService.setFeedbackText(this.feedbackTextFormControl.getRawValue());
        const createFeedbackRequestDto = this.feedbackPopupService.getCreateFeedbackRequestDto();
        this.feedbackResource.sendFeedback(createFeedbackRequestDto).subscribe(
            () => {
                this.feedbackPopupService.hideSpinner();
                this.feedbackPopupService.setFeedbackResultStep();
            },
            () => {
                this.feedbackPopupService.hideSpinner();
                this.feedbackPopupService.setHasError(true);
                this.feedbackPopupService.setFeedbackResultStep();
            }
        );
    }

    public comeBackToTopic(): void {
        if (this.allowReset) {
            this.feedbackPopupService.resetFeedback();
        }
        this.feedbackPopupService.setFeedbackCurrentStep('topic');
    }

    public isFeedbackAboutQuestion(): boolean {
        return this.data.questionId !== undefined && this.feedbackPopupService.feedbackLevel === 'question';
    }

    public ngOnDestroy(): void {
        this.valueChangesSubscription.unsubscribe();
    }
}
